import { SafeAnyType } from 'src/utils/safeAny';
import { isObject, isWeb, isPlainObject } from 'src/utils/stateForm/helpers/cloneDeep/helpers';

export const formStateInnerCloneDeep = <T>(data: T): T => {
  if (data instanceof Date) {
    return new Date(data) as SafeAnyType;
  }

  const isFileListInstance = typeof FileList !== 'undefined' && data instanceof FileList;

  if (isWeb && (data instanceof Blob || isFileListInstance)) {
    return data;
  }

  const isArray = Array.isArray(data);

  if (!isArray && !(isObject(data) && isPlainObject(data))) {
    return data;
  }

  const copy = isArray ? [] : Object.create(Object.getPrototypeOf(data));

  // eslint-disable-next-line no-restricted-syntax
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      copy[key] = formStateInnerCloneDeep(data[key]);
    }
  }

  return copy;
};
